export const BLOCK_PDF = "block_pdf";

export const BLOCK_STEPS = "block_steps";

export const BLOCK_IMAGE_MEDIA = "block_image_media";

export const BLOCK_TABLE = "block_table";

export const SIZE_GUIDE_BLOCK = "size-guide-block";

export const SIZE_GUIDE_BLOCK_TABLE = "size-guide-block-table";
